import React, { useContext, useEffect } from "react";
import { useQuery } from "@apollo/client";
import { Navigate } from "react-router";
import { USER_QUERY } from "graphql/UserQueries";
import UserContext from "contexts/UserContext";
import { ThemeContext } from "contexts/ThemeContext";
import gcTheme from "components/themes/GC/theme";
import lumonusTheme from "components/themes/Lumonus/theme";

const GC_THEME_REGIONS = ["AU", "UK"];

interface Region {
  id: string;
  name: string;
}

const getTheme = (regions: Region[]): any => {
  if (regions.length === 0) return lumonusTheme;
  return regions.every((region: Region) =>
    GC_THEME_REGIONS.includes(region.name),
  )
    ? gcTheme
    : lumonusTheme;
};

const ProtectedRoute = (props: React.PropsWithChildren) => {
  const { data, loading } = useQuery(USER_QUERY, {
    fetchPolicy: "cache-first",
  });
  const themeContext = useContext(ThemeContext);

  useEffect(() => {
    if (data?.user?.firstName) {
      const regions = data?.user?.regions;
      const theme = getTheme(regions);
      themeContext?.setTheme(theme);
    }
  }, [data?.user, themeContext]);

  if (loading) {
    return <div>Loading...</div>;
  }

  if (data?.user?.firstName) {
    return (
      <UserContext.Provider value={data.user}>
        {props.children}
      </UserContext.Provider>
    );
  }

  //if error or query didnt return reqd details
  return <Navigate to="/search" replace />;
};

export default ProtectedRoute;
